import { ToolbarControlTypes, ToolbarControlMargins } from '../constants/toolbar';
export const getMarginLeft = previousType => {
  if (previousType === null) {
    return ToolbarControlMargins.ZERO;
  }
  if (previousType === ToolbarControlTypes.BUTTON) {
    return ToolbarControlMargins.BUTTON;
  }
  return ToolbarControlMargins.DEFAULT;
};